import gql from 'graphql-tag';

export default fields => gql`
query {
  listProviders {
    items {
      __typename
      ${[...['id', 'name'].concat(fields)]}     
    }
  }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Providers/AllQuery.js